import attendanceService from '@/services/attendance.service'

export default {
  namespaced: true,
  state: {
    attendanceRecords: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_ATTENDANCE(state, records) {
      state.attendanceRecords = records
    },
    UPDATE_ATTENDANCE(state, updatedRecord) {
      const index = state.attendanceRecords.findIndex(
        record => record.employeeId === updatedRecord.employeeId && 
                 record.date === updatedRecord.date
      )
      if (index !== -1) {
        state.attendanceRecords.splice(index, 1, updatedRecord)
      } else {
        state.attendanceRecords.push(updatedRecord)
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchAttendance({ commit }, date) {
      try {
        commit('SET_LOADING', true)
        const records = await attendanceService.getByDate(date)
        commit('SET_ATTENDANCE', records)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async markAttendance({ commit }, record) {
      try {
        commit('SET_LOADING', true)
        const updatedRecord = await attendanceService.markAttendance(record)
        commit('UPDATE_ATTENDANCE', updatedRecord)
        return true
      } catch (error) {
        commit('SET_ERROR', error.message)
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    getAttendanceByDate: state => date => {
      return state.attendanceRecords.filter(record => record.date === date)
    },
    getAttendanceByEmployee: state => employeeId => {
      return state.attendanceRecords.filter(record => record.employeeId === employeeId)
    },
    getDailyStats: state => date => {
      const records = state.attendanceRecords.filter(record => record.date === date)
      return {
        total: records.length,
        present: records.filter(r => r.status === 'حاضر').length,
        absent: records.filter(r => r.status === 'غائب').length,
        leave: records.filter(r => r.status === 'إجازة').length,
        mission: records.filter(r => r.status === 'مهمة عمل').length
      }
    }
  }
} 